module.exports = __webpack_public_path__ + "static/media/menu-red.79a2e16c.png";